import React, { createContext, useContext } from 'react';
var MediaContext = /*#__PURE__*/createContext(undefined);
export var MediaProvider = function MediaProvider(_ref) {
  var children = _ref.children,
    mediaContext = _ref.mediaContext;
  return /*#__PURE__*/React.createElement(MediaContext.Provider, {
    value: mediaContext
  }, children);
};

/*
 * This is used for the Proforma attachment field which needs media tokens which are passed down from the portal or Jira frontend
 * */
export function useMediaContext() {
  var mediaContext = useContext(MediaContext);
  var _ref2 = mediaContext !== null && mediaContext !== void 0 ? mediaContext : {},
    mediaApiUploadToken = _ref2.mediaApiUploadToken,
    mediaApiReadToken = _ref2.mediaApiReadToken,
    projectId = _ref2.projectId,
    portalId = _ref2.portalId,
    issueKey = _ref2.issueKey,
    mediaUploadAndViewContexts = _ref2.mediaUploadAndViewContexts,
    mediaReadTokenRefresh = _ref2.mediaReadTokenRefresh,
    mediaApiError = _ref2.mediaApiError;
  return {
    mediaApiUploadToken: mediaApiUploadToken,
    mediaApiReadToken: mediaApiReadToken,
    mediaUploadAndViewContexts: mediaUploadAndViewContexts,
    projectId: projectId,
    portalId: portalId,
    issueKey: issueKey,
    mediaReadTokenRefresh: mediaReadTokenRefresh,
    mediaApiError: mediaApiError
  };
}